import { Icon } from '@busybusy/webapp-react-ui';
import { ArrowDownIcon } from 'assets/icons';
import classNames from 'classnames';

export interface IPickerDropDownIconProps {
  className?: string | object;
}

function PickerDropDownIcon({ className }: IPickerDropDownIconProps) {
  return (
    <span className={classNames('drop-icon', className)}>
      <Icon svg={ArrowDownIcon} />
    </span>
  );
}

export default PickerDropDownIcon;
